import {createStyles, Group, Text} from '@mantine/core';
import React from 'react';

import WarningIcon from 'ui-library/icons/WarningIcon';

const useStyles = createStyles((theme) => ({
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  warning: {
    fontSize: theme.fontSizes.sm,
    backgroundColor: theme.colors.gray[0],
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
    padding: theme.spacing.sm,
  },
  iframe: {
    flexGrow: 1,
    border: 'none',
  },
}));

const WARNING_TEXT = 'This file is external to Benchling and may contain external resources.';

interface IFrameRendererProps {
  url: string;
  title?: string;
  /**
   * @dangerous Enables `allow-scripts` in the iframe sandbox policy, permitting arbitrary
   * script execution. Only enable for content that requires JS to render (e.g. JMP reports).
   */
  dangerouslyAllowScripts?: boolean;
}

export default function IFrameRenderer({
  url,
  title = 'File preview',
  dangerouslyAllowScripts = false,
}: IFrameRendererProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.wrapper}>
      <Group spacing="xs" className={classes.warning}>
        <WarningIcon />
        <Text size="sm">{WARNING_TEXT}</Text>
      </Group>
      <iframe
        sandbox={dangerouslyAllowScripts ? 'allow-scripts' : ''}
        src={url}
        className={classes.iframe}
        title={title}
      />
    </div>
  );
}
